import { render, staticRenderFns } from "./DefaultView.vue?vue&type=template&id=3a5ad410&scoped=true"
import script from "./DefaultView.vue?vue&type=script&lang=js"
export * from "./DefaultView.vue?vue&type=script&lang=js"
import style0 from "./DefaultView.vue?vue&type=style&index=0&id=3a5ad410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5ad410",
  null
  
)

export default component.exports